/*
 * One anchored group (chat makeover M3, #2718). Boxed off with a border and a gap after it, so a song-level comment
 * right below never reads as part of it (Joni). The section colour is an accent bar only: the text stays text-primary.
 */
.group {
  --group-accent: var(--tuna-section-other);

  margin: var(--tuna-spacing-1) 0 var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-1_5);
}

.group[data-section='song'] {
  --group-accent: var(--tuna-section-song);
}

.group[data-section='intro'] {
  --group-accent: var(--tuna-section-intro);
}

.group[data-section='verse'] {
  --group-accent: var(--tuna-section-verse);
}

.group[data-section='chorus'] {
  --group-accent: var(--tuna-section-chorus);
}

.group[data-section='outro'] {
  --group-accent: var(--tuna-section-outro);
}

.group[data-section='bridge'] {
  --group-accent: var(--tuna-section-bridge);
}

.group[data-section='middle8'] {
  --group-accent: var(--tuna-section-middle8);
}

.group[data-section='riff'] {
  --group-accent: var(--tuna-section-riff);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

.accent {
  flex: 0 0 auto;
  width: 4px;
  align-self: stretch;
  min-height: 16px;
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--group-accent);
}

/* A long lyric is cut by the width it has, not by a fixed count (Joni); the full heading is the title */
.heading {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-primary);
}

.show {
  flex: 0 0 auto;
  border: 0;
  background: none;
  padding: var(--tuna-spacing-0_5) var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
  font: inherit;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-primary-main);
  cursor: pointer;
}

.show:hover {
  background-color: var(--tuna-palette-action-hover);
}

.show:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

@media (pointer: coarse) {
  .show {
    min-height: 44px;
  }
}

.thread {
  list-style: none;
  margin: var(--tuna-spacing-0_5) 0 0;
  padding: 0;
}
